import { createContext, useContext, useReducer } from "react";

const initialState = {
  pan: "",
  isBackToSummary: false,
  refId: "",
  dob: "",
  mobileNumber: "",
  mobileCountryCode: "",
  email: "",
  name: "",
  kycTrack: { DtData: [] },
  kycDetails: null,
  aadhaarDetails: null,
  skipKyc: false,
  // ackNumber: "016101A00247095",
  ackNumber: "",
  personalDetails: null,
  fatcaDetails: null,
  accountType: null,
  schemeDetails: null,
  nomineeDetails: null,
  bankDetails: null,
  pennyDropResponse: null,
  documentDetails: null,
  fundDetails: null,
  summary: null,
  EKYCDetails: null,
  popBankDetails: null,
  countriesDetails: null,
  kycBankDetails: null,
  AAAdetails: null,
  District: "",
  statesList: [],
  countriesList: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_BASIC":
      return { ...state, ...action.payload };
    case "SET_KYC_BANK_DETAILS":
      return { ...state, kycBankDetails: action.payload };
    case "SET_PAN":
      return { ...state, pan: action.payload };
    case "SET_DOB":
      return { ...state, dob: action.payload };
    case "SET_MOBILE_NUMBER":
      return { ...state, mobileNumber: action.payload };
    case "SET_EMAIL":
      return { ...state, email: action.payload };
    case "SET_NAME":
      return { ...state, name: action.payload };
    case "SET_KYC_DATA":
      return { ...state, kycDetails: action.payload };
    case "SET_ACK_NUMBER":
      return { ...state, ackNumber: action.payload };
    case "SET_FATCA_DETAILS":
      return { ...state, fatcaDetails: action.payload };
    case "SET_ACCOUNT_TYPE":
      return { ...state, accountType: action.payload };
    case "SET_SCHEME_DETAILS":
      return { ...state, schemeDetails: action.payload };
    case "SET_NOMINEE_DETAILS":
      return { ...state, nomineeDetails: action.payload };
    case "SET_BANK_DETAILS":
      return { ...state, bankDetails: action.payload };
    case "SET_PENNY_DROP_RESPONSE":
      return { ...state, pennyDropResponse: action.payload };
    case "SET_DOCUMENT_DETAILS":
      return { ...state, documentDetails: action.payload };
    case "SET_PERSONAL_DETAILS":
      return { ...state, personalDetails: action.payload };
    case "SET_FUND_DETAILS":
      return { ...state, fundDetails: action.payload };
    case "SET_KYC_TRACK_DETAILS":
      return { ...state, kycTrack: action.payload };
    case "SET_SUMMARY_DETAILS":
      return { ...state, summary: action.payload };
    case "SET_EKYC_DETAILS":
      return { ...state, EKYCDetails: action.payload };
    case "SET_POP_BANK_DETAILS":
      return { ...state, popBankDetails: action.payload };
    case "SET_COUNTRIES_DETAILS":
      return { ...state, countriesDetails: action.payload };
    case "SET_STATUS_BACK_TO_SUMMARY":
      return { ...state, isBackToSummary: action.payload };
    case "SET_AADHAAR_DETAILS":
      return { ...state, aadhaarDetails: action.payload };
    case "SET_AAA_DETAILS":
      return { ...state, AAAdetails: action.payload };
    case "SET_SKIP_KYC":
      return { ...state, skipKyc: action.payload };
    case "SET_DISTRICT":
      return { ...state, District: action.payload };
    default:
      return state;
  }
};

export const NewSubscriberContext = createContext();

const NewSubscriberProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <NewSubscriberContext.Provider value={{ ...state, dispatch }}>
      {children}
    </NewSubscriberContext.Provider>
  );
};

const useNewSubscriberContext = () => {
  const context = useContext(NewSubscriberContext);
  return context;
};

export { NewSubscriberProvider, useNewSubscriberContext };
